import React from 'react';
import Container from 'container';
import Headline from 'headline';
import AsideTabs from 'shared/aside-tabs';
import CustomAsidesGenerator from 'components/generator-custom-asides';

import s from './container-aside.module.scss';

export default function ContainerWAside({
  title = '<h4>headline title</h4>',
  children,
  defaultAsideProps,
  custom_asides,
  asides_list
}) {
  return (
    <Container className={s.root}>
      <div className={s.wrapper}>
        <Headline h1 title className={s.headline} html={title} />
        <div className={s.contentWrapper}>
          {children}
          <div className="post__asides">
            {!custom_asides && defaultAsideProps && <AsideTabs tabs={defaultAsideProps} />}
            {custom_asides && <CustomAsidesGenerator {...{ asides_list }} />}
          </div>
        </div>
      </div>
    </Container>
  );
}
